import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ReplaySubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
const endpoint = environment.api_endpoint;
@Injectable({
  providedIn: 'root',
})
export class SseService {
  private eventSource: EventSource | null = null;
  private sseSubject = new ReplaySubject<any>(1);
  private defaultEndpoint = `${endpoint}/notifier/connect`;

  constructor(
    private zone: NgZone,
    private http: HttpClient,
  ) {}

  initSSE(
    customUrl?: string,
    callback?: (eventData: any) => void,
    onError?: (error: Event) => void,
    reconnect: boolean = true,
  ): EventSource {
    const authToken = localStorage.getItem('accessToken') || '';
    const url =
      customUrl ||
      `${this.defaultEndpoint}?userID=${encodeURIComponent(authToken)}`;

    // Close existing connection if any
    if (this.eventSource) {
      this.eventSource.close();
    }

    // Create new EventSource connection
    this.eventSource = new EventSource(url);

    this.eventSource.onmessage = (event) => {
      this.zone.run(() => {
        try {
          const parsed = JSON.parse(event.data);
          this.sseSubject.next(parsed);
          if (callback) callback(parsed);
        } catch (err) {
          this.sseSubject.next(event.data);
          if (callback) callback(event.data);
        }
      });
    };

    this.eventSource.onerror = (error) => {
      this.zone.run(() => {
        if (onError) onError(error);
      });

      this.eventSource?.close();
      if (reconnect) {
        setTimeout(() => this.initSSE(customUrl, callback, onError), 3000);
      }
    };

    return this.eventSource;
  }

  getMessages() {
    return this.sseSubject.asObservable();
  }
}
